/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `code` - Code Leak
 * * `credentials` - Credentials Leak
 * * `api` - API Key Leak
 * * `secrets` - Secrets Leak
 * * `employees` - Employees Data
 * * `other` - Other
 * @export
 */
export const LeakTypeEnum = {
    Code: 'code',
    Credentials: 'credentials',
    Api: 'api',
    Secrets: 'secrets',
    Employees: 'employees',
    Other: 'other'
} as const;
export type LeakTypeEnum = typeof LeakTypeEnum[keyof typeof LeakTypeEnum];


export function instanceOfLeakTypeEnum(value: any): boolean {
    for (const key in LeakTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(LeakTypeEnum, key)) {
            if (LeakTypeEnum[key as keyof typeof LeakTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeakTypeEnumFromJSON(json: any): LeakTypeEnum {
    return LeakTypeEnumFromJSONTyped(json, false);
}

export function LeakTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeakTypeEnum {
    return json as LeakTypeEnum;
}

export function LeakTypeEnumToJSON(value?: LeakTypeEnum | null): any {
    return value as any;
}

export function LeakTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): LeakTypeEnum {
    return value as LeakTypeEnum;
}

